import * as React from "react";
import SortableTbl from "react-sort-search-table";
import { CSSTransition } from "react-transition-group";

import withServices from "../../../../HOCs/withServices";

import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import "./alertLevelListPage.css";
import { Redirect } from "react-router";
import {
  currentBaseUrl,
  currentProfile,
  getGeneralSmartTableData,
  isUserLoggedIn,
} from "../../../../common/services";

interface IProps {
  services?: any;
  history?: object;
  userType?: string;
}

class AlertLevelListPage extends React.Component<IProps> {
  public state = {
    alertlevel: "",
    datakey: [
      "name",
      "risk_group",
      "field_1",
      "field_2",
      "field_3",
      "field_4",
      "field_5",
      "viewmore",
    ],
    tHead: [
      "Name",
      "Risk Group",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_1
        : "Field-1",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_2
        : "Field-2",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_3
        : "Field-3",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_4
        : "Field-4",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_5
        : "Field-5",
      "Action",
    ],
    baseurl: currentBaseUrl(),
    navigate: false,
    destination: "",
    toLogin: false,
    loaded: false,
    students: [] as any[],
    cohorts: [] as any[],
  };

  constructor(props) {
    super(props);
    this.viewMoreData = this.viewMoreData.bind(this);
    this.handleGenSmartDataLoaded = this.handleGenSmartDataLoaded.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  public async componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
    } else {
      const key1 = "match";

      const {
        services: {
          institutionsAPI,
          currentUserID,
        },
        userType,
      } = this.props;

         const userRes = await institutionsAPI.getUsersAlertLevelListData(
           currentUserID,
           this.props[key1].params.cohort,
           this.props[key1].params.asid,
           this.props[key1].params.id,
           userType
         );

         if (userRes.ok) {
           this.setState({
             students: userRes.data.users,
             alertlevel: userRes.data.level_name,
             loaded: true,
           });
         }
    }
  }

  public onLogout(arg) {
    console.log("Logout in Parent", arg);
    this.setState({ toLogin: true });
  }

  public goBack() {
    //    this.setState({destination: "/home", navigate: true});
    const history: any = this.props.history;
    history.goBack();
  }

  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      this.setState({ loaded: true });
      this.setState({
        [key]: res.response[objkey],
        alertlevel: res.response[objkey][0].risk_group,
      });
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  // public async onSelectCohort(e) {
  //   const {
  //     services: { institutionsAPI, currentUserID },
  //     userType,
  //   } = this.props;

  //   if (e.target.value === "") {
  //     this.setState({ loaded: false, students: [] });
  //     return;
  //   }

  //   const key1 = "match";

  //   const userRes = await institutionsAPI.getUsersAlertLevelListData(
  //     currentUserID,
  //     e.target.value,
  //     this.props[key1].params.asid,
  //     this.props[key1].params.id,
  //     userType
  //   );

  //   if (userRes.ok) {
  //     this.setState({
  //       students: userRes.data.users,
  //       alertlevel: userRes.data.level_name,
  //       loaded: true,
  //     });
  //   }
  // }

  public viewMoreData(props) {
    // navigate to more student data
    // this.setState({navigate: true, destination: this.state.baseurl + "datacenter"});
    // this.setState({navigate: true, destination: this.state.baseurl + "viewstudentdata/" + props.rowData.id});
    const history: any = this.props.history;
    const choice =
      this.props.userType === "students"
        ? "viewstudentdata"
        : "viewteacherdata";
    history.push(`${currentBaseUrl()}${choice}/${props.rowData.id}`);
  }
  public ViewMoreStudentData = (props) => {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <button
          className="blue-button view-more-data"
          onClick={this.viewMoreData.bind(this, props)}
        >
          View More
        </button>
      </td>
    );
  };

  public renderContent = () => {
    const { students, loaded, alertlevel } = this.state;
    return (
      <React.Fragment>
        {students.length ? (
          <div className="alert-table-container">
            <SortableTbl
              tblData={this.state.students}
              tHead={this.state.tHead}
              customTd={[
                {
                  custd: this.ViewMoreStudentData,
                  keyItem: "viewmore",
                  sortable: false,
                },
              ]}
              dKey={this.state.datakey}
              search={true}
              defaultCSS={false}
            />
          </div>
        ) : (
          <div className="alert-table-container">
            <p
              style={{
                color: "#fff",
                fontSize: "18px",
                textTransform: "uppercase",
                fontStyle: "italic",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              There are no {alertlevel} {this.props.userType} in this cohort
            </p>
          </div>
        )}
      </React.Fragment>
    );
  };

  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    const { cohorts, students, alertlevel, loaded } = this.state;

    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="alert-viewpage">
          <Navbar logoutParent={this.onLogout} />
          <div className="alert-level-container">
            <div className="alert-level-header">
              <p className="go-back" onClick={this.goBack}>
                &lt; Back
              </p>

              {loaded ? (
                <h1 className="alert-level-title">
                  <span>{this.state.alertlevel} </span> LEVEL{" "}
                  {this.props.userType}
                </h1>
              ) : (
                ""
              )}
            </div>

            {loaded ? this.renderContent() : ""}
          </div>
        </div>
      </CSSTransition>
    );
  }
}
export default withServices(AlertLevelListPage);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/AlertLevelListPage/alertLevelListPage.Component.tsx